import React, { useEffect } from 'react';
import './contactusform.css'; 


import Nav from "../components/Nav";
import { Footer } from '../components/footer';
import Scrolltop from '../components/Scrolltop';
import { Upperbox } from '../components/Upperbox';

const Contactusform = () => {
  // Scroll to top when the page loads
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the page to the top
  }, []); // Empty dependency array ensures it runs once when the component mounts

  return (
    <div>
      <Upperbox />
      <Nav />
      <div className="contact-page">
      <div>
      <h1 className='business-section-title' data-aos="fade-down">We’d Love to Hear from You</h1>

          </div>
        <div className="contact-layout">
          {/* Left Section: Enquiry Form */}
          <div className="form-section">
            <h2>Make an Enquiry</h2>
            <form className="enquiry-form">
              <div className="form-group">
                <label>Name <span className="required">*</span></label>
                <input type="text" placeholder="Enter your name" required />
              </div>
              <div className="form-group">
                <label>Mobile Number <span className="required">*</span></label>
                <input type="text" placeholder="Enter your mobile number" required />
              </div>
              <div className="form-group">
                <label>Email Address <span className="required">*</span></label>
                <input type="email" placeholder="Enter your email address" required />
              </div>
              <div className="form-group">
                <label>Purpose <span className="required">*</span></label>
                <select required defaultValue="">
                  <option value="" disabled>
                    Select a purpose
                  </option>
                  <option value="delivery">Delivery</option>
                  <option value="takeaway">Takeaway</option>
                  <option value="catering">Catering</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div className="form-group">
                <label>Your Message</label>
                <textarea placeholder="Write your message to Sri Krishnaa here"></textarea>
              </div>
              <button type="submit" className="submit-btn">Submit Enquiry</button>
            </form>
          </div>

          {/* Right Section: Contact Info */}
          <div className="info-section">
            <h2>Get in Touch</h2>
            <div className="contact-info">
            <p><i className="fas fa-phone-alt"></i> <strong>Phone:</strong> +44 7554466904</p>
    <p><i className="fas fa-envelope"></i> <strong>Email:</strong> <a href="mailto:info@srikrishnaaindiancuisine.co.uk">info@srikrishnaaindiancuisine.co.uk</a></p>

              <p>
      <i className="fas fa-map-marker-alt"></i> <strong>Address:</strong><br />
      Sri Krishnaa Authentic Indian Restaurant<br />
      39 Granby St,<br />
      Liverpool, L8 2TU
    </p>
            </div>
            <h2>Opening Hours</h2>
            <div className="business-hours">
    <p>
      <i className="fas fa-calendar-alt"></i> <strong>Monday to Sunday:</strong><br />
      9:00am – 11:00pm
    </p>
  </div>
            <div className="google-map">
            <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2379.0491651994353!2d-2.9582512!3d53.396060399999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487b210056cb7719%3A0xad473a964ed9bd20!2sSri%20Krishnaa%20Indian%20cuisine%20%26%20Takeaway!5e0!3m2!1sen!2sin!4v1740197846540!5m2!1sen!2sin"
    width="100%"
    height="250"
    style={{ border: 0 }}
    allowFullScreen
    loading="lazy"
    title="Sri Krishnaa Authentic Indian Cuisine"
    referrerPolicy="no-referrer-when-downgrade"
/>




</div>




            {/* <div className="social-media">
              <a href="https://www.instagram.com/clasptax/?hl=en" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
            </div> */}
            <div className="social-media">
              <a  target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Scrolltop />
      <Footer />
    </div>
  );
};

export default Contactusform;
